// eslint-disable-next-line no-restricted-imports
import { H4 } from 'dripsy';

export default H4;
